import { render, staticRenderFns } from "./AlliancesAndVillages.vue?vue&type=template&id=d5a8cf36&"
import script from "./AlliancesAndVillages.vue?vue&type=script&lang=js&"
export * from "./AlliancesAndVillages.vue?vue&type=script&lang=js&"
import style0 from "./AlliancesAndVillages.vue?vue&type=style&index=0&id=d5a8cf36&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports